module.exports = __webpack_public_path__ + "img/img15.608d4e48.png";